<template>
  <el-progress :percentage="percentage" :show-text="false" :stroke-width="8" />
</template>
<script setup lang="ts">
const props = defineProps<{
  percentage: number;
}>();
</script>
